import React, { useContext } from "react";
import { AuthContext } from '../../contexts/AuthContext'
import { Col, Row, Button } from "reactstrap";
import Header from "../../layout/Header/Header";

function BotonesRetiros() {
  const { user } = useContext(AuthContext);
  return (
    <>
          <Header />
          {user.menuSocios ?(
      <div className="container">
        <br />
        <br />
        <Row >

        <Col md={4} align="center">
          {user.menuSocios ?(
            <Button href="/Socios" className="botonesMenu" color="success">
              <i class="fas fa-users fa-7x"></i>
              <br />
              <br />
              Socios
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-users fa-7x"></i>
          <br />
          <br />
          Socios
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.menuSocios ?(
            <Button href="/PorRetirar" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              Por Retirar
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          Por Retirar
        </Button> }
          </Col>

          <Col md={4} align="center">
          {user.menuSocios ?(
            <Button href="/Retiros" className="botonesMenu" color="success">
              <i class="fas fa-dollar-sign fa-7x"></i>
              <br />
              <br />
              Retiros
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-dollar-sign fa-7x"></i>
          <br />
          <br />
          Retiros
        </Button> }
          </Col>

        </Row>
<br />
        <Row>
        <Col md={4} align="center">
          {user.menuSocios ?(
            <Button href="/Sociedades" className="botonesMenu" color="success">
              <i class="fas fa-building fa-7x"></i>
              <br />
              <br />
              Sociedades
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-building fa-7x"></i>
          <br />
          <br />
          Sociedades
        </Button> }
          </Col>


        <Col md={4} align="center">
          {user.menuSocios ?(
            <Button href="/ListadoCompraVenta" className="botonesMenu" color="success">
              <i class="fas fa-handshake fa-7x"></i>
              <br />
              <br />
              Compra Venta
            </Button>
          ): <Button disabled className="botonesMenu" color="success">
          <i class="fas fa-handshake fa-7x"></i>
          <br />
          <br />
          Compra Venta
        </Button> }
          </Col>
        </Row>
      </div>
      ): undefined } 
      
    </>
  );
}

export default BotonesRetiros;
